import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { transformB64ToBlob } from '@shared/base64-to-blob';
import { TipoArquivoProntuarioList } from '@shared/model/tipo-arquivo-prontuario-enum.model';
import { AnexoConsultaDto, ArquivoDto, StatusProntuarioEnum, TipoUsuarioEnum } from '@shared/service-proxies/service-proxies';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'visualizar-anexos-consulta',
  templateUrl: './visualizar-anexos.component.html',
  styleUrls: ['./visualizar-anexos.component.scss']
})
export class VisualizarAnexosComponent extends AppComponentBase implements OnInit {
  public newAnexo: AnexoConsultaDto = new AnexoConsultaDto();
  public anexosAtuais: AnexoConsultaDto[] = [];
  public novosAnexos: AnexoConsultaDto[] = [];
  public anexosRemovidos: AnexoConsultaDto[] = [];
  public tipoArquivo: TipoArquivoProntuarioList = new TipoArquivoProntuarioList();

  @ViewChild('file') fileInput!: ElementRef<HTMLInputElement>;

  @Input() anexos: AnexoConsultaDto[] = [];
  @Input() idConsulta: string = undefined;
  @Input() pacienteId: string = undefined;
  @Input() tipoUsuario: TipoUsuarioEnum;
  @Input() isEdit: boolean = false;
  @Output() onFileInsert = new EventEmitter<any>();
  @Output() onFileRemove = new EventEmitter<any>();

  constructor(
    injector: Injector
  ) { super(injector) }

  ngOnInit(): void {
    this.anexosAtuais = [...this.anexos]
  }

  protected onFilesSelected(files: FileList) {
    this.newAnexo.tipoUsuario = this.tipoUsuario;
    this.newAnexo.consultaId = this.idConsulta;
    this.newAnexo.arquivo = this.getNewFile(files[0]);
    this.anexosAtuais.unshift(this.newAnexo);
    this.novosAnexos.unshift(this.newAnexo);
    this.anexosRemovidos = [...this.anexosRemovidos.filter(x => x != this.newAnexo)];
    this.newAnexo = new AnexoConsultaDto();
    this.fileInput.nativeElement.value = ''
    this.onFileRemove.emit(this.anexosRemovidos);
    this.onFileInsert.emit(this.novosAnexos);
  }

  protected removerAnexo(anexo: AnexoConsultaDto) {
    this.newAnexo = new AnexoConsultaDto();
    this.fileInput.nativeElement.value = ''
    this.anexosRemovidos.push(anexo);
    this.novosAnexos = [...this.novosAnexos.filter(x => x != anexo)];
    this.anexosAtuais = [...this.anexosAtuais.filter(x => x != anexo)];
    this.onFileRemove.emit(this.anexosRemovidos);
    this.onFileInsert.emit(this.novosAnexos);
  }

  protected showDeletedButton(anexo: AnexoConsultaDto): boolean {
    if (!anexo.creatorUserId) return true;
    else if (anexo.creatorUserId == this.appSession.userId) return true;
    return false;
  }

  protected showDownloadButton(anexo: AnexoConsultaDto): boolean {
    if (anexo.creatorUserId) return true;
    return false;
  }

  protected downalodFile(anexo: AnexoConsultaDto): void {
    FileSaver.saveAs(anexo.arquivo.urlArquivo, `${anexo.arquivo.nome}.${anexo.arquivo.extensaoArquivo}`);
  }

  private getNewFile(file: File): ArquivoDto {
    const reader = new FileReader();
    let newFile = new ArquivoDto();
    newFile.nome = file.name.split(".")[0];
    newFile.clinicaId = this.appSession.clinicaId;
    newFile.pacienteId = this.pacienteId;
    newFile.vip = false;
    newFile.statusProntuario = StatusProntuarioEnum._3;
    newFile.extensaoArquivo = file.name.split(".")[1];
    newFile.ehPasta = false;
    newFile.tipoArquivo = file.type
    reader.readAsDataURL(file);
    reader.onload = () => {
      newFile.base64Arquivo = reader.result.toString();
    };
    return newFile;
  }
}
